import { render, staticRenderFns } from "./StampCoupon.vue?vue&type=template&id=48ffe0e3&scoped=true&"
import script from "./StampCoupon.vue?vue&type=script&lang=js&"
export * from "./StampCoupon.vue?vue&type=script&lang=js&"
import style0 from "./StampCoupon.vue?vue&type=style&index=0&id=48ffe0e3&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ffe0e3",
  null
  
)

export default component.exports